import Chart from 'chart.js';
import Configs from '@engine/features/dashboard/top_5/dashboard_top5_configs';
import Theme from '@engine/features/dashboard/top_5/dashboard_top5_theme';

function Top5() {
  var chart = null;
  var styles = Theme.styles;
  /**
   * Transforms the Back-End response data
   * into Chart.js digestable objects
   *
   * See lib/models/graph_data.rb in gw_plugin
   *
   * @param {Object} response JSON response
   * @param {Array} theme Alternative color theme
   *
   * @returns {Object} Chart.js datasets with all MIDs(Terminals or Merchants) data
   */

  function buildDataset(response, theme) {
    if (!response.data) {
      return;
    }

    var datasets = Object.keys(response.data).filter(function (item) {
      return item.length > 1;
    }).map(function (objectKey, index) {
      var values = response.data[objectKey];
      var style = theme ? theme[index] : styles[index];
      var dataset = {
        label: objectKey,
        data: [],
        backgroundColor: style.backgroundColor,
        borderColor: style.borderColor,
        borderWidth: 1,
        pointRadius: 3,
        pointHoverRadius: 7,
        pointHoverBorderWidth: 4,
        pointHoverBorderColor: style.pointHoverBorderColor,
        fill: false
      };
      values.forEach(function (element) {
        dataset.data.push({
          y: element.value,
          x: moment(element.day.split(' ')[1]),
          count: element.count
        });
      });
      return dataset;
    });
    return {
      datasets: datasets
    };
  }

  function create(context, theme) {
    chart = new Chart(context, {
      type: 'line',
      data: buildDataset([], theme),
      options: Configs.defaults()
    });
  }

  function forceUpdate(response, theme, options) {
    $.extend(true, chart.options, options);
    chart.data.datasets = buildDataset(response, theme).datasets;
    chart.options.title.text = response.title;
    chart.update();
  }

  function updateDateRange(from, to) {
    $('#date-range').text($(from).val() + ' - ' + $(to).val());
  }

  return {
    create: create,
    forceUpdate: forceUpdate,
    updateDateRange: updateDateRange
  };
}

export default Top5();